module.exports = __webpack_public_path__ + "img/Resolution22-030.82f0a2bb.png";